module.exports = {
  API_URL: process.env.REACT_APP_PUBLIC_API_URL,
  SITE_URL: process.env.REACT_APP_PUBLIC_SITE_URL,
  APP_ROOT: process.env.REACT_APP_PUBLIC_APP_ROOT,
};
